"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatMessageTypeEnum = void 0;
/** Типы сообщений */
var ChatMessageTypeEnum;
(function (ChatMessageTypeEnum) {
  ChatMessageTypeEnum[ChatMessageTypeEnum["plain"] = 1] = "plain";
  ChatMessageTypeEnum[ChatMessageTypeEnum["event_link"] = 2] = "event_link";
  ChatMessageTypeEnum[ChatMessageTypeEnum["leave"] = 5] = "leave";
  ChatMessageTypeEnum[ChatMessageTypeEnum["meeting_complaint"] = 10] = "meeting_complaint";
  ChatMessageTypeEnum[ChatMessageTypeEnum["meeting_complaint_resolved"] = 11] = "meeting_complaint_resolved";
  ChatMessageTypeEnum[ChatMessageTypeEnum["meeting_complaint_rejected"] = 12] = "meeting_complaint_rejected";
})(ChatMessageTypeEnum = exports.ChatMessageTypeEnum || (exports.ChatMessageTypeEnum = {}));
